import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';

Vue.use(VueToast);

function openToast(message, type) {
  Vue.$toast.open({
    message,
    type,
  });
}

function getSettings(link) {
  return axios.post(link).then((response) => {
    if (response.data.success) {
      return response;
    }

    openToast(response.data.message, 'error');
    response.data = null;

    return response;
  });
}

export function getPrintPrices() {
  return getSettings('/printPrice/list');
}

export function deletePrice(id) {
  return axios.post(`/printPrice/deletePrice/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.printingCostSuccessfullyDeleted'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function editPrice(price) {
  return axios.post('/printPrice/editPrice', { price }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function addPrice(name) {
  return axios.post('/printPrice/addPrice', { name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.printingCostSuccessfullyAdded'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}
